import { render, staticRenderFns } from "./SelectInputMuseum.vue?vue&type=template&id=24b5b180&"
import script from "./SelectInputMuseum.vue?vue&type=script&lang=js&"
export * from "./SelectInputMuseum.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputMuseum.vue?vue&type=style&index=0&id=24b5b180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports